import React from 'react'
import { Card, CardBody } from 'reactstrap'

const UnitReviews = ({ review }) => {
    return (
        <Card className="gs-surface gs-unit-review">
            <CardBody className="gs-unit-review__body">
                <i>{review}</i>
            </CardBody>
        </Card>
        
    )
}

export default UnitReviews
